/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAccountResponse,
  ApiAuthBeneficiaryDto,
  ApiAuthCodeDto,
  ApiAuthEmailDto,
  ApiAuthHttpResponse,
  ApiAuthJwtDto,
  ApiAuthLogoutDto,
  ApiAuthPublicKeyDto,
  ApiBeneficiaryActivationCreate,
  ApiChangePasswordDto,
  ApiCreateActiveAccount,
  ApiCreateAssistantDto,
  ApiCreateBeneficiaryCreateByInviteCode,
  ApiCreateBeneficiaryDto,
  ApiCreateBeneficiaryHttpResponse,
  ApiCreateGenerateEmailCode,
  ApiCreateResetPassword,
  ApiGenerateEmailHttpCodeResponse,
  ApiLoginDto,
  ApiProfileResponse,
  ApiProfileStatusResponse,
  ApiResetPasswordCodeDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Auth<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Authenticates via owner-auth (email/password). Returns owner-auth access JWT as token and syncs legacy account like login/personal-code; no AccountSession row.
   *
   * @tags Authentication
   * @name AuthControllerLogin
   * @summary Logging user
   * @request POST:/auth/login
   * @secure
   * @response `200` `ApiAuthHttpResponse`
   */
  authControllerLogin = (data: ApiLoginDto, params: RequestParams = {}) =>
    this.request<ApiAuthHttpResponse, ApiBaseError>({
      path: `/auth/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerCreateBeneficiary
   * @summary Create beneficiary account
   * @request POST:/auth/beneficiary
   * @secure
   * @response `200` `ApiCreateBeneficiaryHttpResponse`
   * @response `400` `void`
   * @response `404` `void`
   * @response `429` `void` Rate limited: at most one request per 30s per authenticated account (E1261 REQUEST_TOO_FREQUENT).
   */
  authControllerCreateBeneficiary = (
    data: ApiCreateBeneficiaryDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCreateBeneficiaryHttpResponse, ApiBaseError>({
      path: `/auth/beneficiary`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerRegenerateBeneficiaryInvite
   * @summary Regenerate beneficiary registration invite
   * @request POST:/auth/beneficiary/regenerate
   * @secure
   * @response `200` `ApiCreateBeneficiaryHttpResponse`
   * @response `400` `void`
   * @response `404` `void`
   */
  authControllerRegenerateBeneficiaryInvite = (
    data: ApiAuthBeneficiaryDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiCreateBeneficiaryHttpResponse, ApiBaseError>({
      path: `/auth/beneficiary/regenerate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerCreateAssistant
   * @summary Create assistant
   * @request POST:/auth/assistant
   * @secure
   * @response `200` `ApiAccountResponse`
   * @response `404` `void`
   */
  authControllerCreateAssistant = (
    data: ApiCreateAssistantDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAccountResponse, ApiBaseError>({
      path: `/auth/assistant`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Creates or resends a repository invitation via owner-auth (same flow as beneficiary/regenerate when an invite already exists; creates invite when create used dontSendInviteEmail).
   *
   * @tags Authentication
   * @name AuthControllerSendNewInviteToBeneficiary
   * @summary Send new invite to beneficiary
   * @request POST:/auth/beneficiary/invite
   * @secure
   * @response `200` `ApiProfileResponse`
   * @response `400` `void`
   * @response `404` `void`
   */
  authControllerSendNewInviteToBeneficiary = (
    data: ApiAuthBeneficiaryDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiProfileResponse, ApiBaseError>({
      path: `/auth/beneficiary/invite`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Optional body field twoFactorQuestions is ignored by the server (backward compatibility).
   *
   * @tags Authentication
   * @name AuthControllerActivateBeneficiaryProfile
   * @summary Activation beneficiary profile
   * @request POST:/auth/beneficiary/activate
   * @secure
   * @response `200` `ApiAccountResponse`
   * @response `400` `void`
   * @response `404` `void`
   */
  authControllerActivateBeneficiaryProfile = (
    data: ApiBeneficiaryActivationCreate,
    params: RequestParams = {},
  ) =>
    this.request<ApiAccountResponse, ApiBaseError>({
      path: `/auth/beneficiary/activate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Delete beneficiary profile.
   *
   * @tags Authentication
   * @name AuthControllerRemoveBeneficiaryProfile
   * @summary Delete beneficiary profile
   * @request DELETE:/auth/beneficiary/{id}
   * @secure
   * @response `200` `ApiProfileStatusResponse`
   * @response `400` `void`
   */
  authControllerRemoveBeneficiaryProfile = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.request<ApiProfileStatusResponse, ApiBaseError>({
      path: `/auth/beneficiary/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description ASSISTANT profile is validated in owner-backend; challenge signing and ECIES encryption are performed in owner-auth (internal).
   *
   * @tags Authentication
   * @name AuthControllerGenerateEncryptedMessage
   * @summary Generate encrypted message
   * @request POST:/auth/encrypted-message
   * @secure
   * @response `200` `string`
   * @response `400` `void`
   * @response `404` `void`
   */
  authControllerGenerateEncryptedMessage = (
    data: ApiAuthPublicKeyDto,
    params: RequestParams = {},
  ) =>
    this.request<string, ApiBaseError>({
      path: `/auth/encrypted-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Exchanges decrypted assistant challenge JWT for owner-auth assistant access JWT. The same JWT is returned as token for Authorization; no legacy AccountSession row is created.
   *
   * @tags Authentication
   * @name AuthControllerLoginViaDecryptedMessage
   * @summary Logging via decrypted message
   * @request POST:/auth/login/decrypted-message
   * @secure
   * @response `200` `ApiAuthHttpResponse`
   * @response `400` `void`
   */
  authControllerLoginViaDecryptedMessage = (
    data: ApiAuthJwtDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAuthHttpResponse, ApiBaseError>({
      path: `/auth/login/decrypted-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Validates owner-auth access JWT passed as code (syncs account if needed). Returns the same JWT as token for Authorization; no legacy AccountSession row is created.
   *
   * @tags Authentication
   * @name AuthControllerLoginViaPersonalAccountCode
   * @summary Logging in via the PA code
   * @request POST:/auth/login/personal-code
   * @secure
   * @response `200` `ApiAuthHttpResponse`
   * @response `400` `void`
   */
  authControllerLoginViaPersonalAccountCode = (
    data: ApiAuthCodeDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAuthHttpResponse, ApiBaseError>({
      path: `/auth/login/personal-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerLogout
   * @summary Log out
   * @request POST:/auth/logout
   * @secure
   * @response `200` `boolean`
   */
  authControllerLogout = (data: ApiAuthLogoutDto, params: RequestParams = {}) =>
    this.request<boolean, ApiBaseError>({
      path: `/auth/logout`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerChangePassword
   * @summary Change password
   * @request POST:/auth/password/change
   * @secure
   * @response `200` `ApiAccountResponse`
   */
  authControllerChangePassword = (
    data: ApiChangePasswordDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAccountResponse, ApiBaseError>({
      path: `/auth/password/change`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerGenerateEmailCode
   * @summary Generating and sending an email with the generated verification code
   * @request POST:/auth/email-code
   * @secure
   * @response `200` `ApiGenerateEmailHttpCodeResponse`
   * @response `400` `void`
   * @response `429` `void` Rate limited: at most one code-email request per 30s per client IP (REQUEST_TOO_FREQUENT).
   */
  authControllerGenerateEmailCode = (
    data: ApiCreateGenerateEmailCode,
    params: RequestParams = {},
  ) =>
    this.request<ApiGenerateEmailHttpCodeResponse, ApiBaseError>({
      path: `/auth/email-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerActivateAccount
   * @summary Activation account
   * @request POST:/auth/account/activate
   * @secure
   * @response `200` `ApiAccountResponse`
   * @response `400` `void`
   * @response `429` `void` Rate limited: at most one OTP verification request per 2s per client IP (REQUEST_TOO_FREQUENT).
   */
  authControllerActivateAccount = (
    data: ApiCreateActiveAccount,
    params: RequestParams = {},
  ) =>
    this.request<ApiAccountResponse, ApiBaseError>({
      path: `/auth/account/activate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerActivateAccountAfterExternalRegistration
   * @summary Account activation after end-to-end registration
   * @request POST:/auth/account/activate-external
   * @secure
   * @response `200` `boolean`
   */
  authControllerActivateAccountAfterExternalRegistration = (
    data: ApiAuthPublicKeyDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/auth/account/activate-external`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerResetPassword
   * @summary Reset password
   * @request POST:/auth/password/reset
   * @secure
   * @response `200` `ApiAccountResponse`
   * @response `400` `void`
   * @response `429` `void` Rate limited: at most one OTP verification request per 2s per client IP (REQUEST_TOO_FREQUENT).
   */
  authControllerResetPassword = (
    data: ApiCreateResetPassword,
    params: RequestParams = {},
  ) =>
    this.request<ApiAccountResponse, ApiBaseError>({
      path: `/auth/password/reset`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerForgotPassword
   * @summary Sending a password reset code to an email if you forgot your password
   * @request POST:/auth/password/forgot
   * @secure
   * @response `200` `boolean`
   * @response `400` `void`
   * @response `429` `void` Rate limited: at most one code-email request per 30s per client IP (REQUEST_TOO_FREQUENT).
   */
  authControllerForgotPassword = (
    data: ApiAuthEmailDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, ApiBaseError>({
      path: `/auth/password/forgot`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Authentication
   * @name AuthControllerResetPasswordByCode
   * @summary Reset password by code
   * @request POST:/auth/password/code
   * @secure
   * @response `200` `ApiAccountResponse`
   * @response `400` `void`
   * @response `429` `void` Rate limited: at most one OTP verification request per 2s per client IP (REQUEST_TOO_FREQUENT).
   */
  authControllerResetPasswordByCode = (
    data: ApiResetPasswordCodeDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAccountResponse, ApiBaseError>({
      path: `/auth/password/code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description DEPRECATED: TOTP (authenticator-app) flow is not used in current clients. Scheduled for removal after callers stop using it.
   *
   * @tags Authentication
   * @name AuthControllerChangeTotpEnabled
   * @summary Enabling two-factor authentication
   * @request POST:/auth/totp
   * @deprecated
   * @secure
   * @response `200` `boolean`
   * @response `401` `void`
   */
  authControllerChangeTotpEnabled = (params: RequestParams = {}) =>
    this.request<boolean, ApiBaseError>({
      path: `/auth/totp`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Optional body field twoFactorQuestions is ignored by the server (backward compatibility).
   *
   * @tags Authentication
   * @name AuthControllerRegisterBeneficiaryByInvitationCode
   * @summary Register beneficiary by invitation code
   * @request POST:/auth/beneficiary/register
   * @secure
   * @response `200` `ApiAuthHttpResponse`
   * @response `400` `void`
   * @response `404` `void`
   */
  authControllerRegisterBeneficiaryByInvitationCode = (
    data: ApiCreateBeneficiaryCreateByInviteCode,
    params: RequestParams = {},
  ) =>
    this.request<ApiAuthHttpResponse, ApiBaseError>({
      path: `/auth/beneficiary/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
 * @description DEPRECATED: will be removed after all clients stop calling it. Do not use in new integrations.
 *
 * @tags Authentication
 * @name AuthControllerIsEmailExists
 * @summary Checking email for existence
 * @request GET:/auth/email/exists
 * @deprecated
 * @secure
 * @response `200` `({
  \* Template custom: data-contract-jsdoc *\
    isEmailExists?: boolean,

} | boolean)` Checking email for existence
 * @response `429` `void` At most one request per 30s per client IP (REQUEST_TOO_FREQUENT).
 */
  authControllerIsEmailExists = (
    query: {
      /* Template custom: data-contract-jsdoc */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      | {
          /* Template custom: data-contract-jsdoc */
          isEmailExists?: boolean;
        }
      | boolean,
      ApiBaseError
    >({
      path: `/auth/email/exists`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
 * No description
 *
 * @tags Authentication
 * @name AuthControllerVerifyEmailCode
 * @summary Checking the verification code sent to the specified email
 * @request GET:/auth/email-code/verify
 * @secure
 * @response `200` `({
  \* Template custom: data-contract-jsdoc *\
    success?: boolean,

} | boolean)` Verification result
 * @response `400` `void`
 * @response `429` `void` Rate limited: at most one OTP verification request per 2s per client IP (REQUEST_TOO_FREQUENT).
 */
  authControllerVerifyEmailCode = (
    query: {
      /* Template custom: data-contract-jsdoc */
      email: string;
      /* Template custom: data-contract-jsdoc */
      code: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      | {
          /* Template custom: data-contract-jsdoc */
          success?: boolean;
        }
      | boolean,
      ApiBaseError
    >({
      path: `/auth/email-code/verify`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description DEPRECATED: TOTP (authenticator-app) flow is not used in current clients. Scheduled for removal after callers stop using it.
   *
   * @tags Authentication
   * @name AuthControllerGenerateTotpSecret
   * @summary Generate totp secret
   * @request GET:/auth/totp-secret
   * @deprecated
   * @secure
   * @response `200` `string`
   * @response `401` `void`
   */
  authControllerGenerateTotpSecret = (
    query: {
      /* Template custom: data-contract-jsdoc */
      token: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, ApiBaseError>({
      path: `/auth/totp-secret`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
